import { useSelector } from 'react-redux';
import { FormInputField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Sex, TitlePrefix } from '@mews-commander/data-access';
import { LocalizedSubsectionTitle } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { DateField, EnumSelectField, SelectField } from '@mews-commander/form';
import { getCountryOptions } from '@mews-commander/legacy-entities/src/ducks/countries';
import { useBirthdateDateLimits } from './useBirthdateDateLimits';

export const PersonalInfo = ({ isUserProvisioned }: { isUserProvisioned: boolean }) => {
    const countriesOptions = useSelector(getCountryOptions);
    const dateLimits = useBirthdateDateLimits();

    return (
        <Stack vertical spacing="300">
            <LocalizedSubsectionTitle textKey={TextKey.PersonalInfo} />

            <EnumSelectField
                name="titlePrefix"
                label={<LocalizedText textKey={TextKey.Title} />}
                enumClass={TitlePrefix}
                enumPrefix="TitlePrefix"
            />

            <FormInputField
                name="firstName"
                required
                readOnly={isUserProvisioned}
                label={<LocalizedText textKey={TextKey.FirstName} />}
            />

            <FormInputField
                name="lastName"
                required
                readOnly={isUserProvisioned}
                label={<LocalizedText textKey={TextKey.LastName} />}
            />

            <FormInputField name="secondLastName" label={<LocalizedText textKey={TextKey.SecondLastName} />} />

            <FormInputField required name="userId" readOnly label={<LocalizedText textKey={TextKey.UserId} />} />

            <DateField
                name="birthDate"
                label={<LocalizedText textKey={TextKey.DateOfBirth} />}
                mode="iso"
                {...dateLimits}
            />

            <FormInputField name="birthPlace" label={<LocalizedText textKey={TextKey.PlaceOfBirth} />} />

            <SelectField
                name="nationalityCode"
                options={countriesOptions}
                label={<LocalizedText textKey={TextKey.Nationality} />}
            />

            <EnumSelectField
                name="sex"
                label={<LocalizedText textKey={TextKey.Sex} />}
                enumClass={Sex}
                enumPrefix="Sex"
            />
        </Stack>
    );
};
